module.exports = __webpack_public_path__ + "img/woman-full-white.9c6c49cb.svg";